module.exports = __webpack_public_path__ + "static/media/super-saude.9fb36613.svg";